import {
  JOB_RECRUIT_FORM_FETCHING,
  JOB_RECRUIT_FORM_FAILED,
  JOB_RECRUIT_FORM_SUCCESS,
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case JOB_RECRUIT_FORM_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case JOB_RECRUIT_FORM_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case JOB_RECRUIT_FORM_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
